import failedAnimation from '../../assets/animations/failed.json';
import loadingAnimation from '../../assets/animations/loading.json';
import pendingDesktopAnimation from '../../assets/animations/pendingDesktop.json';
import pendingGenericAnimation from '../../assets/animations/pendingGeneric.json';
import pendingMobileAnimation from '../../assets/animations/pendingMobile.json';
import successAnimation from '../../assets/animations/success.json';

import type { ChkAnimationType } from './ChkLottieAnimation.types';

export const ANIMATION_MAP = {
  pendingGeneric: pendingGenericAnimation,
  success: successAnimation,
  failed: failedAnimation,
  loading: loadingAnimation,
  pendingDesktop: pendingDesktopAnimation,
  pendingMobile: pendingMobileAnimation,
} as const;

export const NON_BRANDABLE_ANIMATIONS: ChkAnimationType[] = [
  'success',
  'failed',
];

export const REDUCED_MOTION_FRAME_MAP: ReadonlyMap<ChkAnimationType, number> =
  new Map<ChkAnimationType, number>([
    ['loading', 0.75],
    ['pendingGeneric', 0.14],
    ['pendingDesktop', 0.75],
    ['pendingMobile', 0.75],
    ['success', 1],
    ['failed', 1],
  ]);

export const DEFAULT_ANIMATION_SPEED = 1;
